var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('Header'),_c('div',{staticClass:"join"},[_c('div',{staticClass:"join-input"},[_c('input',{attrs:{"id":"search","type":"text","placeholder":"请输入您的意向加盟城市"},on:{"input":_vm.change}}),_c('i',{staticClass:"icon"})])])],1)}
var staticRenderFns = []

export { render, staticRenderFns }